export const STATUS_BADGE_CONFIG = {
  COMPLETED: {
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-700',
    icon: '✓',
    label: 'Completed',
  },
  IN_PROGRESS: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-600',
    icon: '⏱',
    label: 'In Progress',
  },
  NOT_STARTED: {
    bg: 'bg-gray-50',
    border: 'border-gray-200',
    text: 'text-gray-500',
    icon: '—',
    label: 'Not Started',
  },
};

export const TABLE_CONFIG = {
  ASSESSMENT: {
    cols: 5,
    headers: ['Assessment', 'Category', 'Attempts', 'Best Score', 'Last Attempted'],
  },
  COURSE: {
    cols: 6,
    headers: ['Course', 'Type', 'Progress', 'Status', 'Completed', 'Certificate'],
  },
  CONTENT: {
    cols: 4,
    headers: ['Title', 'Type', 'Assigned'],
  },
};